import { Card, CardBody } from '@repo/ui';
import { TabNavigation, type Tab } from '@xtnd/web/shared/components';
import { useTabParams } from '../../../hooks';
import { TrustReconciliationSummary } from './TrustReconciliationSummary';
import { TrustPivotTable } from './TrustPivotTable';
import { TrustTransactionTable } from './TrustTransactionTable';

const DEFAULT_TAB = 'by-client';

export function TrustDashboardView() {
  const { tabParam, handleTabChange } = useTabParams({ defaultTab: DEFAULT_TAB });

  const innerTabs: Tab[] = [
    {
      id: 'by-client',
      label: 'By Client',
      icon: 'HiUsers',
      content: (
        <CardBody className="p-0">
          <TrustPivotTable />
        </CardBody>
      ),
    },
    {
      id: 'all-transactions',
      label: 'All Transactions',
      icon: 'HiClipboardList',
      content: (
        <CardBody className="p-0">
          <TrustTransactionTable />
        </CardBody>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      {/* Summary Statistics */}
      <TrustReconciliationSummary />

      {/* Main Content Tabs */}
      <Card variant="outlined" padding="none">
        {/* Inner Tabs */}
        <div className="border-b border-xtnd-dark-100 dark:border-xtnd-dark-600 px-6 py-4">
          <TabNavigation tabs={innerTabs} activeTab={tabParam} onTabChange={handleTabChange} />
        </div>
      </Card>
    </div>
  );
}
